import React from 'react'
import asset from './images/linux.png'
export const Linux = (props) => <img src={asset} alt="sistema operacional linux" {...props} />
